// /opt/isp_erp/frontend/src/pages/admin/servicios/Servicios.jsx
import React, { useState, useEffect } from "react";
import axios from "../../../api/axios";
import "./Servicios.css";

export default function Servicios() {
  const [servicios, setServicios] = useState([]);
  const [planes, setPlanes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("servicios");
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({
    // Para servicios
    name: "",
    service_type: "INTERNET",
    description: "",
    is_active: true,
    // Para planes
    service_id: "",
    speed_mbps: "",
    price: "",
    features: ""
  });

  useEffect(() => {
    fetchServicios();
    fetchPlanes();
  }, []);

  const fetchServicios = async () => {
    try {
      const res = await axios.get("/services");
      setServicios(res.data);
    } catch (error) {
      console.error("Error cargando servicios:", error);
    }
  };

  const fetchPlanes = async () => {
    try {
      const res = await axios.get("/services/plans");
      setPlanes(res.data);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      name: "",
      service_type: "INTERNET",
      description: "",
      is_active: true,
      service_id: "",
      speed_mbps: "",
      price: "",
      features: ""
    });
    setEditingItem(null);
  };

  const openEditModal = (item) => {
    setEditingItem(item);
    setFormData({
      name: item.name,
      service_type: item.service_type || "INTERNET",
      description: item.description || "",
      is_active: item.is_active,
      service_id: item.service_id || "",
      speed_mbps: item.speed_mbps || "",
      price: item.price || "",
      features: item.features || ""
    });
    setShowModal(true);
  };

  const handleSubmit = async () => {
    try {
      if (activeTab === "servicios") {
        if (editingItem) {
          await axios.put(`/services/${editingItem.id}`, formData);
        } else {
          await axios.post("/services", formData);
        }
      } else {
        if (editingItem) {
          await axios.put(`/services/plans/${editingItem.id}`, formData);
        } else {
          await axios.post("/services/plans", formData);
        }
      }
      setShowModal(false);
      resetForm();
      fetchServicios();
      fetchPlanes();
      alert(`✅ ${editingItem ? 'Actualizado' : 'Creado'} exitosamente`);
    } catch (error) {
      alert(error.response?.data?.detail || "Error al guardar");
    }
  };

  const handleDelete = async (item) => {
    if (!window.confirm(`¿Eliminar ${item.name}?`)) return;

    try {
      if (activeTab === "servicios") {
        await axios.delete(`/services/${item.id}`);
      } else {
        await axios.delete(`/services/plans/${item.id}`);
      }
      fetchServicios();
      fetchPlanes();
      alert("✅ Eliminado correctamente");
    } catch (error) {
      alert(error.response?.data?.detail || "Error al eliminar");
    }
  };

  const handleToggleActive = async (item) => {
    try {
      if (activeTab === "servicios") {
        await axios.put(`/services/${item.id}`, { is_active: !item.is_active });
      } else {
        await axios.put(`/services/plans/${item.id}`, { is_active: !item.is_active });
      }
      fetchServicios();
      fetchPlanes();
    } catch (error) {
      alert("Error al cambiar estado");
    }
  };

  const getServiceIcon = (type) => {
    switch(type) {
      case 'INTERNET': return '🌐';
      case 'TV': return '📺';
      case 'DUOPACK': return '📦';
      default: return '📡';
    }
  };

  if (loading) {
    return (
      <div className="servicios-loading-container">
        <div className="servicios-loading-spinner"></div>
        <p>Cargando servicios y planes...</p>
      </div>
    );
  }

  return (
    <div className="servicios-container">
      {/* Header */}
      <div className="servicios-header">
        <div className="header-left">
          <div className="header-icon">📡</div>
          <div>
            <h1>Servicios y Planes</h1>
            <p>Gestión de servicios y planes disponibles</p>
          </div>
        </div>
        <div className="header-actions">
          <button
            onClick={() => {
              setActiveTab("servicios");
              resetForm();
              setShowModal(true);
            }}
            className="btn-primary"
          >
            ➕ Nuevo Servicio
          </button>
          <button
            onClick={() => {
              setActiveTab("planes");
              resetForm();
              setShowModal(true);
            }}
            className="btn-success"
          >
            ➕ Nuevo Plan
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div className="servicios-tabs">
        <button
          onClick={() => setActiveTab("servicios")}
          className={`tab-btn ${activeTab === "servicios" ? "active" : ""}`}
        >
          <span className="tab-icon">📋</span>
          Servicios
          <span className="tab-count">{servicios.length}</span>
        </button>
        <button
          onClick={() => setActiveTab("planes")}
          className={`tab-btn ${activeTab === "planes" ? "active" : ""}`}
        >
          <span className="tab-icon">📊</span>
          Planes
          <span className="tab-count">{planes.length}</span>
        </button>
      </div>

      {/* Listado de Servicios */}
      {activeTab === "servicios" && (
        <div className="servicios-grid">
          {servicios.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">📡</div>
              <p className="empty-title">No hay servicios registrados</p>
              <p className="empty-subtitle">Crea un nuevo servicio para comenzar</p>
            </div>
          ) : (
            servicios.map(serv => (
              <div key={serv.id} className="servicio-card">
                <div className="servicio-header">
                  <div className="servicio-icon">
                    {getServiceIcon(serv.service_type)}
                  </div>
                  <div className="servicio-titulo">
                    <h3>{serv.name}</h3>
                    <p className="servicio-tipo">{serv.service_type}</p>
                  </div>
                  <button
                    onClick={() => handleToggleActive(serv)}
                    className={`status-toggle ${serv.is_active ? 'active' : 'inactive'}`}
                  >
                    {serv.is_active ? 'Activo' : 'Inactivo'}
                  </button>
                </div>

                <p className="servicio-descripcion">
                  {serv.description || 'Sin descripción'}
                </p>

                <div className="servicio-planes">
                  <p className="planes-titulo">
                    Planes ({serv.planes?.length || 0})
                  </p>
                  <div className="planes-lista">
                    {serv.planes?.map(plan => (
                      <div key={plan.id} className="plan-mini">
                        <span className="plan-mini-nombre">{plan.name}</span>
                        <span className="plan-mini-precio">${plan.price}</span>
                      </div>
                    ))}
                    {(!serv.planes || serv.planes.length === 0) && (
                      <p className="sin-planes">Sin planes asociados</p>
                    )}
                  </div>
                </div>

                <div className="servicio-actions">
                  <button
                    onClick={() => openEditModal(serv)}
                    className="action-btn edit"
                    title="Editar servicio"
                  >
                    ✏️
                  </button>
                  <button
                    onClick={() => handleDelete(serv)}
                    className="action-btn delete"
                    title="Eliminar servicio"
                  >
                    🗑️
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      )}

      {/* Listado de Planes */}
      {activeTab === "planes" && (
        <div className="planes-container">
          {planes.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">📊</div>
              <p className="empty-title">No hay planes registrados</p>
              <p className="empty-subtitle">Crea un nuevo plan para comenzar</p>
            </div>
          ) : (
            <div className="planes-table-container">
              <table className="planes-table">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Servicio</th>
                    <th>Velocidad</th>
                    <th className="text-right">Precio</th>
                    <th>Estado</th>
                    <th className="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {planes.map(plan => {
                    const servicio = servicios.find(s => s.id === plan.service_id);
                    return (
                      <tr key={plan.id} className="plan-row">
                        <td className="plan-nombre">{plan.name}</td>
                        <td>
                          <div className="plan-servicio">
                            <span className="servicio-icon-small">
                              {getServiceIcon(servicio?.service_type)}
                            </span>
                            {servicio?.name || 'N/A'}
                          </div>
                        </td>
                        <td className="plan-velocidad">
                          {plan.speed_mbps ? `${plan.speed_mbps} Mbps` : '-'}
                        </td>
                        <td className="plan-precio text-right">${plan.price}</td>
                        <td>
                          <button
                            onClick={() => handleToggleActive(plan)}
                            className={`status-toggle small ${plan.is_active ? 'active' : 'inactive'}`}
                          >
                            {plan.is_active ? 'Activo' : 'Inactivo'}
                          </button>
                        </td>
                        <td className="plan-acciones">
                          <button
                            onClick={() => openEditModal(plan)}
                            className="action-icon edit"
                            title="Editar plan"
                          >
                            ✏️
                          </button>
                          <button
                            onClick={() => handleDelete(plan)}
                            className="action-icon delete"
                            title="Eliminar plan"
                          >
                            🗑️
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* Modal para crear/editar */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content modal-medium">
            <div className="modal-header">
              <div className="modal-header-left">
                <div className="modal-header-icon">
                  {activeTab === 'servicios' ? '📡' : '📊'}
                </div>
                <div>
                  <h3>
                    {editingItem ? 'Editar' : 'Nuevo'} {activeTab === 'servicios' ? 'Servicio' : 'Plan'}
                  </h3>
                  <p>Complete los datos del {activeTab === 'servicios' ? 'servicio' : 'plan'}</p>
                </div>
              </div>
              <button
                onClick={() => {
                  setShowModal(false);
                  resetForm();
                }}
                className="modal-close"
              >
                ✕
              </button>
            </div>

            <div className="modal-body">
              <div className="form-container">
                {/* Nombre (común) */}
                <div className="form-group">
                  <label className="form-label required">
                    Nombre <span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    className="form-input"
                    placeholder={activeTab === 'servicios' ? 'Ej: Internet Residencial' : 'Ej: 100 MEGAS'}
                    required
                  />
                </div>

                {/* Selector de servicio (solo para planes) */}
                {activeTab === "planes" && (
                  <div className="form-group">
                    <label className="form-label required">
                      Servicio <span className="required-star">*</span>
                    </label>
                    <select
                      value={formData.service_id}
                      onChange={(e) => setFormData({...formData, service_id: e.target.value})}
                      className="form-select"
                      required
                    >
                      <option value="">Seleccione servicio</option>
                      {servicios.map(s => (
                        <option key={s.id} value={s.id}>{s.name}</option>
                      ))}
                    </select>
                  </div>
                )}

                {/* Tipo de servicio (solo para servicios) */}
                {activeTab === "servicios" && (
                  <div className="form-group">
                    <label className="form-label required">
                      Tipo de Servicio <span className="required-star">*</span>
                    </label>
                    <select
                      value={formData.service_type}
                      onChange={(e) => setFormData({...formData, service_type: e.target.value})}
                      className="form-select"
                    >
                      <option value="INTERNET">🌐 Internet</option>
                      <option value="TV">📺 TV</option>
                      <option value="DUOPACK">📦 Duopack</option>
                    </select>
                  </div>
                )}

                {/* Campos específicos para planes */}
                {activeTab === "planes" && (
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">Velocidad (Mbps)</label>
                      <input
                        type="number"
                        value={formData.speed_mbps}
                        onChange={(e) => setFormData({...formData, speed_mbps: e.target.value})}
                        className="form-input"
                        placeholder="Ej: 100"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label required">
                        Precio ($) <span className="required-star">*</span>
                      </label>
                      <input
                        type="number"
                        step="0.01"
                        value={formData.price}
                        onChange={(e) => setFormData({...formData, price: e.target.value})}
                        className="form-input"
                        placeholder="Ej: 35.00"
                        required
                      />
                    </div>
                  </div>
                )}

                {/* Descripción */}
                <div className="form-group">
                  <label className="form-label">Descripción</label>
                  <textarea
                    value={formData.description}
                    onChange={(e) => setFormData({...formData, description: e.target.value})}
                    className="form-textarea"
                    rows="3"
                    placeholder="Descripción del servicio/plan"
                  />
                </div>

                {/* Características (solo para planes) */}
                {activeTab === "planes" && (
                  <div className="form-group">
                    <label className="form-label">Características</label>
                    <textarea
                      value={formData.features}
                      onChange={(e) => setFormData({...formData, features: e.target.value})}
                      className="form-textarea"
                      rows="2"
                      placeholder="Separar por comas: 100 Mbps, Wifi incluido, etc."
                    />
                  </div>
                )}

                {/* Estado activo */}
                <div className="form-group checkbox">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={formData.is_active}
                      onChange={(e) => setFormData({...formData, is_active: e.target.checked})}
                      className="checkbox-input"
                    />
                    <span className="checkbox-text">Activo</span>
                  </label>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                onClick={() => {
                  setShowModal(false);
                  resetForm();
                }}
                className="btn-secondary"
              >
                Cancelar
              </button>
              <button
                onClick={handleSubmit}
                className="btn-primary"
              >
                {editingItem ? 'Actualizar' : 'Crear'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
